import { patchRequest } from '@/core';
import { savedLoadPlanningSearches } from '@/requests';

export default async function updateMultipleSavedLoadPlanningSearchesRequest(patch) {
	let url = savedLoadPlanningSearches.getPath();
	let response = await patchRequest(url, {}, patch);
	return response;
}
